export const GET_APPS = "GET_APPS";
export const APPS_LOADING = "APPS_LOADING";
export const GET_APP_CATALOG = "GET_APP_CATALOG";
export const APP_CATALOG_LOADING = "APP_CATALOG_LOADING";
export const TOGGLE_NOTIFICATION = "TOGGLE_NOTIFICATION";